import styled from "styled-components";

const AppWrapper = styled.div`
  font-family: "Segoe UI";
`;

export { AppWrapper };
